import $ from "jquery";

$(document).ready(function(){
    let controls = '.c-card-carousel-alpha__controls ';
    let slickImageFrame = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        speed: 500,
        cssEase: 'ease-in-out',
        nextArrow: $(controls + '.next-arrow'),
        prevArrow: $(controls + '.prev-arrow'),
        asNavFor: '.c-card-carousel-alpha__bottom',
    };
    let slickContentFrame = {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        speed: 750,
        asNavFor: '.c-card-carousel-alpha__top',
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    };
    $('.c-card-carousel-alpha__top').slick(slickImageFrame);
    $('.c-card-carousel-alpha__bottom').slick(slickContentFrame);

});